<template>
  <b-modal
    hide-footer
    id="modal-loyalty-consent"
    ref="modal-loyalty-consent"
    class="modal-md"
    title-tag="p"
  >
    <button type="button" class="close" slot="modal-header-close" aria-label="Close">
      <span></span>
      <span></span>
    </button>
    <div class="modal-body modal-body--form py-6 px-5 px-lg-0">
      <div class="container-fluid">
        <div class="row justify-content-center text-center">
          <div class="col-12 col-lg-11 mb-5">
            <div class="mb-5">
              <img
                crossorigin="anonymous"
                itemprop="logo"
                :src="logoRadisson"
                height="35"
                alt="RADISSON"
              />
            </div>
            <div class="modal-body__title text-justify">
              {{ translate('modalLoyaltyAccessToMemberOnly') }}
            </div>
          </div>

          <div class="col-12 col-lg-11">
            <div class="row">
              <div class="col-lg-6 order-lg-1 mb-4">
                <div class="modal-body__subtitle mb-3">
                  {{ translate('modalLoyaltyNotAMember') }}
                </div>
                <div class="modal-body__button mb-3">
                  <button
                    @click="$emit('bookAndJoin')"
                    class="btn btn-primary w-md-100 book-and-join-cta"
                  >
                    {{ translate('modalLoyaltyBookAndJoin') }}
                  </button>
                </div>
              </div>
              <div class="col-lg-6 order-lg-0">
                <div class="modal-body__subtitle mb-3">
                  {{ translate('modalLoyaltyAlreadyAMember') }}
                </div>
                <div class="modal-body__button">
                  <button @click="$emit('signIn')" class="btn btn-secondary w-md-100">
                    {{ translate('modalLoyaltySignIn') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'LoyaltyConsentModal',
  data: () => ({
    logoRadisson: `${assetsUrl}/img/logos/radisson-rewards.svg`
  })
}
</script>
